var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgSun = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.16667 2.5H15.8333C16.75 2.5 17.5 3.24167 17.5 4.16667V15.8333C17.5 16.2754 17.3244 16.6993 17.0118 17.0118C16.6993 17.3244 16.2754 17.5 15.8333 17.5H4.16667C3.72464 17.5 3.30072 17.3244 2.98816 17.0118C2.67559 16.6993 2.5 16.2754 2.5 15.8333V4.16667C2.5 3.24167 3.24167 2.5 4.16667 2.5ZM7.81268 10C7.81268 8.7946 8.79482 7.8125 10.0003 7.8125C11.2057 7.8125 12.1879 8.7946 12.1879 10C12.1879 11.2054 11.2057 12.1875 10.0003 12.1875C8.79482 12.1875 7.81268 11.2054 7.81268 10ZM13.4572 8.56901L15.6151 9.64681C15.9068 9.79264 15.9068 10.2074 15.6106 10.3555L13.4526 11.4333L14.216 13.721C14.3208 14.0286 14.0268 14.3226 13.7169 14.2201L11.4291 13.4567L10.3512 15.6146C10.2054 15.9063 9.79064 15.9063 9.6448 15.6146L8.56694 13.4567L6.27907 14.2201C5.97144 14.3249 5.67748 14.0309 5.78003 13.721L6.54341 11.431L4.38543 10.3532C4.09375 10.2074 4.09375 9.79264 4.38543 9.64681L6.54341 8.56673L5.78003 6.27897C5.6752 5.97135 5.96916 5.67741 6.27907 5.77995L8.56922 6.54329L9.64707 4.38542C9.79291 4.09375 10.2076 4.09375 10.3535 4.38542L11.4336 6.54557L13.7215 5.78223C14.0291 5.67741 14.3231 5.97135 14.2205 6.28125L13.4572 8.56901ZM7.93801 12.0622C9.07511 13.1992 10.9255 13.1992 12.0626 12.0622C13.1997 10.9251 13.1997 9.07487 12.0626 7.93783C10.9255 6.80078 9.07511 6.80078 7.93801 7.93783C6.80091 9.07487 6.80091 10.9251 7.93801 12.0622Z",
    fill: "url(#paint0_linear_676_498)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_676_498",
    x1: 5.23057,
    y1: -12.645,
    x2: 31.5261,
    y2: 5.61303,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8A5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.536953,
    stopColor: "#FF695C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF475E"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSun);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/sun.ab5f173a5cf444fcbd58da038789bf0d.svg";